import useSWR from 'swr'
import { Single_SchoolGroup } from '@graphql/queries'

const useSchoolGroup = (id) => {
  const { data, error, mutate, isValidating } = useSWR(id ? [
    Single_SchoolGroup,
    id,
  ] : null)

  return {
    schoolGroup: data?.schoolGroup,
    error,
    mutate,
    isValidating,
    isLoading: !error && !data,
  }
}

export { useSchoolGroup }
